import { Link } from 'react-router-dom'
import { FaQuestionCircle, FaTicketAlt } from 'react-icons/fa'

const Home = () => {
  return (
    <>
      <section className="heading">
        <h1>What do you need to track?</h1>
        <p>Please choose form the option below</p>
      </section>
      <Link to='/new-ticket' className="btn btn-reverse btn-block">
        <FaQuestionCircle /> Create New Ticket
      </Link>
      <Link to='/tickets' className="btn btn-block">
        <FaTicketAlt /> View My Tickets
      </Link>
    </>
  )
}
export default Home